export const RECEIVE_LIST_USER = 'RECEIVE_LIST_USER';
export const UPDATE_USER_ROOMS = 'UPDATE_USER_ROOMS';
export const RECEIVE_SEARCHED_USERS = 'RECEIVE_SEARCHED_USERS';
export const CLEAR_SEARCHED_USERS = 'CLEAR_SEARCHED_USERS';
